module.exports = __webpack_public_path__ + "assets/img/正骨5.1400c3c3.jpg";